<template>
  <pt-cps-payment class="pt-cps-payment__page"></pt-cps-payment>
</template>

<script>
import PtCpsPayment from 'cps/data-statistics/pt-cps-payment/withData'
export default {
  name: 'pt-cps-payment__view',
  components: {
    'pt-cps-payment': PtCpsPayment
  }
}
</script>
